import { createFileRoute, redirect } from '@tanstack/react-router'
import { assetQuery, siteQuery } from '../../data/assets.ts'
import { AssetForm } from '../../features/assets/AssetForm.tsx'

export const Route = createFileRoute('/_app/assets/add')({
	component: AssetForm,
	beforeLoad: async ({ context: { queryClient, isAdmin, sub, impersonation } }) => {
		const hasProtectionsSub = sub.features.includes('protections')
		if (!isAdmin || (!impersonation && !hasProtectionsSub)) {
			throw redirect({ to: '/' })
		}
		await Promise.all([
			queryClient.ensureQueryData(assetQuery(impersonation, { enabled: hasProtectionsSub })),
			queryClient.ensureQueryData(siteQuery(impersonation, { enabled: hasProtectionsSub })),
		])
	},
})
